import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterCompaniesValue,
  UniversalFilterCompaniesModes,
  UniversalFilterCompaniesFilterState,
  UniversalFilterCompaniesOnChange
} from '../../UniversalFilterCompanies.types';

interface UniversalFilterCompaniesFilterStateOptions {
  onChange: UniversalFilterCompaniesOnChange;
}

function useUniversalFilterCompaniesFilterState({
  onChange
}: UniversalFilterCompaniesFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterCompaniesFilterState) => void
  >(
    (filterState) => {
      const companyNanoIds = filterState?.companyNanoIds;

      if (filterState?.mode === UniversalFilterCompaniesModes.CONTAINS_ANY_OF) {
        onChange(isEmpty(companyNanoIds) ? undefined : companyNanoIds);
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterCompaniesValue
    ) => UniversalFilterCompaniesFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue)) {
      return {
        mode: UniversalFilterCompaniesModes.CONTAINS_ANY_OF,
        companyNanoIds: filterValue
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterCompaniesFilterState;
